export const getUserData = (user)=>{
    return {type:'GET_USER',user}
}